import DefaultIcon from "src/assets/icon/default_user_icon.svg";
import { S3_URL } from "src/config";

const getUserIconUrl = (iconPath: string | null, userId: number) => {
    if (iconPath === null || userId === null) return DefaultIcon;

    // Full URL (new v3 uploads or migrated CloudFront URLs)
    if (iconPath.startsWith("http")) return iconPath;

    return `${S3_URL}/ProfileImages/${userId}/${iconPath}`;
};

export default getUserIconUrl;
